import { FilterGenerator } from './filter-generator';

export class ValueFilterGenerator implements FilterGenerator {
  generate(value: string): Array<string> {
    return [value];
  }
}
